import classNames from 'classnames';
import fp from 'lodash/fp';
import React from 'react';
import { branch, renderNothing } from 'recompose';

const Icon = ({ className, icon, size, ...otherProps }) => (
  <i
    className={classNames({
      [`fa fa-${icon}`]: true,
      [`fa-${size}x`]: fp.inRange(1, 6)(size)
    }, className)}
    aria-hidden='true'
    {...otherProps} />
);

export default branch(
  ({ icon }) => icon === undefined,
  renderNothing
)(Icon);



// WEBPACK FOOTER //
// ./src/components/proxy/icon.js